module.exports = __webpack_public_path__ + "img/TomasCerna.4d67f32d.png";